import { collection, query, where, getDocs } from 'firebase/firestore';
import { database } from '../../config/firebase';

export let getIsLeagueNameTaken = async (name = '') => {
  let leaguesQuery = query(
    collection(database, 'leagues'),
    where('name', '==', name)
  );
  let result = await getDocs(leaguesQuery);

  return Boolean(result.docs.length);
};
